export function Beian() {
  return (
    <p className="my-2 text-center">
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-primary transition-colors text-xs font-sans text-foreground/60"
      >
        鄂ICP备2025137109号
      </a>
    </p>
  );
}
